import { gql } from '@edreamsodigeo/frontend-api-client';

export const USER_SEGMENT = gql`
  query UserSegment {
    userSegment {
      segment
    }
  }
`;
